import { createClient } from '@supabase/supabase-js';

const url = (process.env.REACT_APP_SUPABASE_URL || '').trim();
const anonKey = (process.env.REACT_APP_SUPABASE_ANON_KEY || '').trim();

/** Internal email domain when users sign in with username only. */
export const DASHBOARD_AUTH_DOMAIN = (
  process.env.REACT_APP_DASHBOARD_AUTH_DOMAIN || 'dashboard.local'
).trim();

export function isSupabaseConfigured() {
  return Boolean(url && anonKey);
}

export function usernameToEmail(username) {
  const raw = String(username || '').trim();
  if (!raw) return '';
  if (raw.includes('@')) return raw;
  return `${raw}@${DASHBOARD_AUTH_DOMAIN}`;
}

let client = null;

export function getSupabase() {
  if (!isSupabaseConfigured()) return null;
  if (!client) {
    client = createClient(url, anonKey);
  }
  return client;
}
